export default __webpack_public_path__ + "static/media/iconfinder-icon-1.31a2d24c.png";